export const getArticle = (content = {}, pathname = "") => {
	const articleId = decodeURIComponent(pathname.split("/").filter(Boolean).at(-1));

	const allDocs = Object.entries(content).reduce((a, [k, v]) => ({ ...a, ...v }), {});

	return Object.entries(allDocs).reduce((a, [k, v]) => ({ ...a, [v.endpoint?.value || k]: v }), {})?.[articleId];
};
